<template>
    <div class="icon-detail">
        <div class="detail-box">
            <p class="num-box">
                <span>{{ listItem.tradeAmount > 0 ? '+' : '' }}{{ listItem.tradeAmount | numDevide100 }}</span>
            </p>
            <p class="detail-wrapper">
                <span class="detail-title">类型： </span>
                <span class="detail-cont">{{ listItem.tradeType | typeToText('tradeType') }}</span>
            </p>
            <p class="detail-wrapper">
                <span class="detail-title">操作者： </span>
                <span class="detail-cont">{{ listItem.createMemberFullName }}</span>
            </p>
            <p class="detail-wrapper">
                <span class="detail-title">操作者账号： </span>
                <span class="detail-cont">{{ listItem.createMemberName }}</span>
            </p>
            <p class="detail-wrapper">
                <span class="detail-title">时间： </span>
                <span class="detail-cont">{{ listItem.createTime | dateTime }}</span>
            </p>
            <p class="detail-wrapper">
                <span class="detail-title">说明： </span>
                <span class="detail-cont">{{ listItem.detail }}</span>
            </p>
        </div>
        <div class="detail-table" v-if="detailArr.length > 0">
            <a-table
                bordered
                :columns="columns"
                :data-source="detailArr"
                :pagination="false"
                :rowKey="(record, index) => index"
            >
                <template slot="tradeAmount" slot-scope="text">
                    <span>{{ text | numDevide100 }}</span>
                </template>
            </a-table>
            <common-pagination
                class="the-pagenation"
                show-size-selector
                :hideOnSinglePage="false"
                :total="total"
                :default-page="page"
                :default-page-size="10"
                @page-change="pageChange"
                @size-change="showSizeChange"/>
        </div>
    </div>
</template>
<script>
    import { coinDetail } from '@/store/api/share/team';
    import commonPagination from '@/modules/knowledge-operation/components/common-pagination.vue';

    export default {
        components: {
            commonPagination,
        },
        props: {
            listItem: {
                type: Object,
                default: () => ({}),
            },
        },
        data: () => ({
            columns: [
                {
                    title: '分配对象',
                    dataIndex: 'destinationAccountFullName',
                },
                {
                    title: '分配数额',
                    dataIndex: 'tradeAmount',
                    scopedSlots: { customRender: 'tradeAmount' },
                },
            ],
            detailArr: [],
            page: 1,
            pageSize: 10,
            total: 0,
        }),
        mounted() {
            // 1学币分配 2学币充值 3专栏订阅 4打赏 目前只有分配才获取明细列表
            if ([1].indexOf(this.listItem.tradeType) > -1) {
                this.getCoinDetail();
            }
        },
        methods: {
            pageChange(page) {
                this.page = page;
                this.list = [];
                this.getCoinDetail();
            },
            showSizeChange(page, pageSize) {
                this.page = 1;
                this.pageSize = pageSize;
                this.list = [];
                this.getCoinDetail();
            },
            // 列表明细
            async getCoinDetail() {
                const {
                    data: { items, recordCount },
                } = await coinDetail({
                    grantId: this.listItem.businessId,
                    page: this.page,
                    pageSize: this.pageSize,
                });
                this.detailArr = items;
                this.total = recordCount;
            },
        },
    };
</script>
<style lang="less">
.icon-detail {
    .detail-box {
        position: relative;
        .num-box {
            position: absolute;
            right: 0;
            top: -12px;
            border-radius: 50%;
            font-size: 30px;
            font-weight: bold;
            text-align: center;
            color: #00aeff;
        }
        .detail-wrapper {
            font-size: 14px;
            margin-bottom: 10px;
            .detail-title {
                color: #888888;
            }
            .detail-cont {
                color: #333333;
            }
        }
    }
    .detail-table {
        margin-top: 20px;
        .ant-table-wrapper {
            margin-bottom: 20px;
        }
    }
    .ant-table-pagination.ant-pagination {
        float: none;
        background: #fff;
        text-align: center;
        & .ant-pagination-item {
            min-width: 32px !important;
            height: 32px !important;
            border-radius: 2px;
        }
    }
    .ant-pagination-item a {
        vertical-align: middle;
        min-width: 32px !important;
        height: 32px !important;
        background-color: #ffffff;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
    }
    .ant-pagination-item.ant-pagination-item-active a,
    .ant-pagination-item.ant-pagination-item-active a {
        color: #1890ff !important;
        border-radius: 2px;
        background: #fff;
        border: 1px solid #1890ff;
    }

    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link {
        vertical-align: middle;
        margin-top: 2px;
        min-width: 32px !important;
        height: 32px !important;
        border: 1px solid rgba(0, 0, 0, 0.15) !important;
        display: inline-block !important;
        border-radius: 2px;
    }
    .ant-pagination-options {
        margin-top: 4px;
    }
    .coin-page-outer {
        background: #fff;
        padding: 20px;
        border-radius: 6px;
    }
    .dropdown-no-icon .ant-select-arrow .anticon.anticon-down svg,
    .ant-select-selection .ant-select-arrow .anticon.anticon-up svg,
    .ant-select-selection .ant-select-arrow .anticon.anticon-down svg,
    .ant-pagination-item-link .anticon-right svg,
    .ant-pagination-item-link .anticon-left svg {
        display: block !important;
    }
    .anticon-down::before {
        display: none !important;
    }
    .anticon-right::before {
        display: none !important;
    }
    .anticon-left::before {
        display: none !important;
    }
}
</style>
